import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { ForgotPasswordEndPoient } from "src/app/Data/service/global.service";
import { AuthService } from "../service/auth.service";
import { Router } from "@angular/router";
import { passwordValidators } from '../../validators/passwordValidators';
import { Language } from "src/app/landing-pages/thi/thi-translations";
import { normalizeThiLang } from "src/app/landing-pages/thi/thi-lang.util";
const Swal = require('sweetalert2')

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"]
})

export class ForgotPasswordComponent implements OnInit {
  
  public show: boolean = false;
  landingLang: Language = "ar";
  userRegistId :any;
  otpCode: number;
  userLanguage:string;

  userForgetPassword:any;

  ForgetPassword = new FormGroup({
    'user_id': new FormControl(null),
    'otp': new FormControl('',[Validators.required ]),
    'security_code': new FormControl('', [Validators.required]),
    'password': new FormControl('', passwordValidators),
    });
  constructor
  ( private authService:AuthService ,
    private spinner: NgxSpinnerService , 
    private Router:Router,
  ) 
  {

  }

  private getLocalizedMsg(res: any): string {
    if (this.userLanguage === 'ar' && res?.messageAr) return res.messageAr;
    if (this.userLanguage === 'he' && res?.messageHe) return res.messageHe;
    return res?.messageEn || res?.message || '';
  }

  submitForget(ForgetPassword) {
    let model = {
      "user_id": Number(this.userForgetPassword),
      "otp": this.ForgetPassword.value.otp,
      "security_code": this.ForgetPassword.value.security_code,
      "password": this.ForgetPassword.value.password
    };
    this.spinner.show();

    this.authService.ForgotPassword(ForgotPasswordEndPoient.POST, model).subscribe({
      next: (response) => {
        this.spinner.hide();
        if (response.status == 200) {
          Swal.fire({
            icon: 'success',
            title: this.getLocalizedMsg(response),
            confirmButtonColor: '#141414',
          });
          this.Router.navigate(['/login']);
          localStorage.removeItem('userForgetPassword');
        } else {
          Swal.fire({
            icon: 'error',
            title: this.getLocalizedMsg(response),
            confirmButtonColor: '#141414',
          });
        }
      },
      error: (err) => {
        this.spinner.hide();
        const body = err?.error || {};
        Swal.fire({
          icon: 'error',
          title: this.getLocalizedMsg(body) || 'Something went wrong',
          confirmButtonColor: '#141414',
        });
      }
    });
  };

  ngOnInit() {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);

    this.userForgetPassword = JSON.parse(localStorage.getItem('userForgetPassword'));
    this.userLanguage = localStorage.getItem('curentLang');
    this.landingLang = normalizeThiLang(this.userLanguage);
  } 

  showPassword() {
    this.show = !this.show;
    const passwordInput = document.querySelector('input[name="login[password]"]') as HTMLInputElement;
    if (passwordInput) {
      passwordInput.focus();
    }
    this.handlePasswordValidation(this.ForgetPassword);
  }

  handlePasswordValidation(formGroup: FormGroup) {
    const passwordControl = formGroup.get('password');
    if (passwordControl) {
      passwordControl.markAsTouched();
    }
  }

  get passwordChecks() {
    const pw = this.ForgetPassword?.get('password')?.value || '';
    return {
      minLength:   pw.length >= 8,
      uppercase:   /[A-Z]/.test(pw),
      lowercase:   /[a-z]/.test(pw),
      number:      /[0-9]/.test(pw),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(pw),
    };
  }
}
